// Shared geometry and interaction defaults for MUI X chart primitives.
export const SERIES_HIGHLIGHT = {
  highlightScope: { fade: 'global', highlight: 'series' },
} as const;

export const ITEM_HIGHLIGHT = {
  highlightScope: { fade: 'global', highlight: 'item' },
} as const;

export const PIE_EMPHASIS = {
  ...ITEM_HIGHLIGHT,
  faded: { additionalRadius: -6, opacity: 0.3 },
  highlighted: { additionalRadius: 6 },
} as const;

export const PIE_CHART_GEOMETRY = {
  innerRadius: '62%',
  outerRadius: '88%',
  cornerRadius: 6,
  paddingAngle: 2,
} as const;
